import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
export function PainSection() {
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6
  }} className="py-20 px-4 bg-black/40" data-id="element-154">
      <div className="max-w-6xl mx-auto" data-id="element-155">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-156">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex justify-center" data-id="element-157">
            <div className="relative" data-id="element-158">
              <AlertTriangleIcon className="w-32 h-32 md:w-48 md:h-48 text-red-500 opacity-20" data-id="element-159" />
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-160">
                <AlertTriangleIcon className="w-24 h-24 md:w-36 md:h-36 text-red-500" data-id="element-161" />
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-162">
            <h2 className="text-3xl md:text-4xl font-black mb-6 text-red-400" data-id="element-163">
              El "Sueño Americano" se ha convertido para muchos en una
              "Pesadilla de 9 a 5"
            </h2>
            <p className="text-lg leading-relaxed text-gray-300 mb-4" data-id="element-164">
              Estás atrapado en un almacén, una cocina o una obra,{' '}
              <span className="text-amber-400 font-semibold" data-id="element-165">
                cambiando tu salud por un cheque que apenas cubre la renta.
              </span>
            </p>
            <p className="text-lg leading-relaxed text-gray-300 mb-4" data-id="element-166">
              Sabes que la Inteligencia Artificial está cambiando el mundo, pero
              te sientes bloqueado. Piensas:{' '}
              <span className="italic" data-id="element-167">"Eso es para americanos"</span>,
              <span className="italic" data-id="element-168"> "Mi inglés no es bueno"</span>, o
              <span className="italic" data-id="element-169">
                {' '}
                "No entiendo nada de computadoras"
              </span>
              . Y mientras tanto,{' '}
              <span className="text-amber-400 font-semibold" data-id="element-170">
                la oportunidad de tu vida se te escapa de las manos.
              </span>
            </p>
            <p className="text-lg leading-relaxed text-gray-300" data-id="element-171">
              Cada día que pasa sin aprender IA, es un día más que dependes de
              un jefe que no te valora.
            </p>
          </motion.div>
        </div>
      </div>
    </motion.section>;
}